import LodashInflection from 'lodash-inflection'
window._.mixin(LodashInflection)
